import Vue from 'vue';
import { portfolioService } from '@/services/services';
import {error} from '@/utils/log'
import {extractJsonDate, formatDate, removeDateStrTimezone} from "../../utils/formatters";

export default {

    async loadLastPredicted({state, commit, dispatch}){
      this.loading = true;
      commit('setLoading', true);

      portfolioService
        .getLastPredictedSymbols()
        .then(response => {
          commit('setLoading', false);
          if (!response.Items || response.Items.length == 0) {
            commit('updateHistory',[]);
            commit('setShowTable', true);
          } else {
            commit('updateHistory',response.Items);
            commit('setShowTable', true);
          }
        })
        .catch(() => {
          commit('invalidate');
          commit('setShowTable', false);
          error.log("Errot loading prediction history");
        });
    }

}
